import React, { useEffect, useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import { auth } from "../../firebase";
import Spinner from "../../Components/Spinner";

export default function CheckoutForm({ clientSecret }) {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (!auth.currentUser) {
            return window.location.replace("/login")
        }
    }, [])
    useEffect(() => {
        if (!stripe) {
            return;
        }

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.protocol}//${window.location.host}/pro/checkout/order`,
            },
        });
        if (error.type === "card_error" || error.type === "validation_error") {

            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            {isLoading
                ? <div style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0, background: "rgba(255,255,255,.8)", zIndex: 10000 }} className="flex aic jcc fdc">
                    <Spinner style={{ minHeight: 100 }} />
                    <p style={{ fontWeight: "bold", opacity: .6, textAlign: 'center', marginTop: 10 }}>Processing your  transaction...</p>
                </div>
                : null
            }
            <PaymentElement id="payment-element" />
            <button disabled={!stripe || !elements} className="b3" style={{ marginTop: 20 }} id="submit">
                Pay Now
            </button>
            {/* Show any error or success messages */}
            {message && <div className="error flex aic jcc" style={{ marginTop: 20, width: "fit-content", minHeight: 30 }}>{message}</div>}
        </form>
    );
}